export const EMPTY_STATES = {
  noCompletionsToday: "Nothing checked off yet. Start with whichever feels easiest.",
  statsInsufficientData: "Keep tracking for a few more days to see trends here.",
} as const;
